import { Box, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';

const OtherViewer = (props) => {
  const {
    fileName,
    contentUrl,
  } = props;

  return <Box textAlign="center" p={4}>
    <Typography variant="h6" gutterBottom>
      {fileName}
    </Typography>
    <Typography color="textSecondary">
      Vista previa no disponible
    </Typography>
    {contentUrl && (
      <Typography variant="body2" style={{ 
        wordBreak: 'break-all',
      }}>
        {contentUrl.length > 100 ? `${contentUrl.substring(0, 100)}...` : contentUrl}
      </Typography>
    )}
  </Box>;
};

OtherViewer.defaultProps = {
  fileName: '',
  contentUrl: '',
};

OtherViewer.propTypes = {
  fileName: PropTypes.string,
  contentUrl: PropTypes.string,
};

export default OtherViewer;
